import _debounce from 'lodash/debounce';
import Glide from '@glidejs/glide';

const slider = document.querySelector('.shop-images__thumbs');
if (slider) {

  const glide = new Glide('.shop-images__thumbs', {
    type: 'carousel',
    startAt: 0,
      gap: 20,
      perView: slider.getAttribute('data-carousel-slides') || 3,

      breakpoints: {
          400: {
              perView: 2,
          }

      }
  });


  glide.on('build.after', e => {
    const thumbs = document.querySelectorAll('.shop-images__thumb');
     if(thumbs) {
       [].forEach.call(thumbs, thumb => {
         thumb.addEventListener('click', e => {
           e.preventDefault();
           const src = e.currentTarget.getAttribute('data-image');
           document.querySelector('.shop-images__main img').setAttribute('src', src);
         });
       });
     }
  });


  glide.mount();
//  const thumbs
}
